import React, { useEffect, useState } from "react";
import api from "../../../api";
import styles from "./BankAccountRegister.module.css";

export default function BankAccountRegister() {
  const [form, setForm] = useState({
    serial_no: "",
    created_at: new Date().toISOString().slice(0, 10), // ✅ 기본값: 오늘 날짜
    alias: "",
    bank_name: "우리은행",
    account_number: "",
  });

  const [accounts, setAccounts] = useState([]);
  const [message, setMessage] = useState("");

  const BANKS = [
    "우리은행",
    "신한은행",
    "KB국민은행",
    "하나은행",
    "NH농협은행",
    "IBK기업은행",
    "신협",
  ];

  const fetchAccounts = async () => {
    const res = await api.get("/bank-accounts/");
    setAccounts(res.data);
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.serial_no) {
      setMessage("⚠️ 번호를 입력해주세요.");
      return;
    }

    try {
      await api.post("/bank-accounts/", form);
      setMessage("✅ 통장이 등록되었습니다.");
      fetchAccounts();
      setForm({
        serial_no: "",
        created_at: new Date().toISOString().slice(0, 10),
        alias: "",
        bank_name: "우리은행",
        account_number: "",
      });
    } catch (err) {
      console.error(err);
      setMessage("❌ 등록 중 오류 발생");
    }
  };

  return (
    <div className={styles.wrap}>
      <h2>통장 등록</h2>

      <form onSubmit={handleSubmit} className={styles.form}>
        {/* 번호 */}
        <label>번호</label>
        <input
          type="number"
          name="serial_no"
          value={form.serial_no}
          onChange={handleChange}
          placeholder="예: 1"
        />

        {/* 개설일자 */}
        <label>개설일자</label>
        <input
          type="date"
          name="created_at"
          value={form.created_at}
          onChange={handleChange}
        />

        {/* 구분(통장부기명) */}
        <label>구분(통장부기명)</label>
        <input
          type="text"
          name="alias"
          value={form.alias}
          onChange={handleChange}
          placeholder="예: 용역, 환경사업 등"
        />

        {/* 거래은행 */}
        <label>거래은행</label>
        <select
          name="bank_name"
          value={form.bank_name}
          onChange={handleChange}
        >
          {BANKS.map((b) => (
            <option key={b} value={b}>
              {b}
            </option>
          ))}
        </select>

        {/* 통장 계좌번호 */}
        <label>통장 계좌번호</label>
        <input
          type="text"
          name="account_number"
          value={form.account_number}
          onChange={handleChange}
          placeholder="예: 1005-704-103602"
        />

        <button type="submit" className={styles.submitBtn}>
          등록
        </button>
      </form>

      {message && <p className={styles.message}>{message}</p>}

      {/* ✅ 목록 테이블 */}
      <table className={styles.table}>
        <thead>
          <tr>
            <th>번호</th>
            <th>개설일자</th>
            <th>구분(통장부기명)</th>
            <th>거래은행</th>
            <th>통장 계좌번호</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((a) => (
            <tr key={a.id}>
              <td>{a.serial_no}</td>
              <td>
                {a.created_at
                  ? new Date(a.created_at).toLocaleDateString()
                  : "-"}
              </td>
              <td>{a.alias || "-"}</td>
              <td>{a.bank_name}</td>
              <td>{a.account_number}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
